export const passwordRequirementsMessage =
  "Password must be at least 8 characters long, and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol";
//from https://stackoverflow.com/questions/58767980/aws-cognito-password-regex-specific-to-aws-cognito

export const passwordRegEx =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,256}$/;

export const emailRequiredMessage = "Email is required";
export const emailValidationErrorMessage = "Please provide a valid email address";
